module.exports = __webpack_public_path__ + "static/img/viral_04.5cfb7b09.jpg";